import { genzoTrackActionEvent } from '@alexis/helpers/genzo';
import { generateCUID } from '@alexis/helpers/identity';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import RefreshIcon from '@icons/refresh.svg';
import WarningIcon from '@icons/warning.svg';

import { updateTriggerSearchCounter } from '@redux/actions/triggerSearchCounterActions';
import {
  getPageViewIdState,
  getTranslationsState,
  getTriggerSearchCounterState,
  getUserState,
} from '@redux/selectors';

import styles from './FlightMissingNoticeBar.module.scss';

interface FlightMissingNoticeBarProps {
  wegoAnalyticsClientId: string | undefined;
  wegoAnalyticsClientSessionId: string | undefined;
}

const FlightMissingNoticeBar = ({
  wegoAnalyticsClientId,
  wegoAnalyticsClientSessionId,
}: FlightMissingNoticeBarProps) => {
  const translations = useSelector(getTranslationsState);
  const triggerSearchCounter = useSelector(getTriggerSearchCounterState);
  const user = useSelector(getUserState);
  const { home: pageViewId } = useSelector(getPageViewIdState);

  const dispatch = useDispatch();

  const onRefreshClick = () => {
    dispatch(updateTriggerSearchCounter(triggerSearchCounter + 1));

    if (wegoAnalyticsClientId && wegoAnalyticsClientSessionId) {
      const eventData = {
        id: pageViewId,
        category: 'search_results',
        object: 'error_message',
        action: 'refresh',
        value: 'polling_failed',
      };

      genzoTrackActionEvent(
        API_BASE_URL,
        wegoAnalyticsClientId,
        wegoAnalyticsClientSessionId,
        user?.userHash,
        eventData,
        generateCUID(),
      );
    }
  };

  useEffect(() => {
    if (wegoAnalyticsClientId && wegoAnalyticsClientSessionId) {
      const eventData = {
        id: pageViewId,
        category: 'search_results',
        object: 'error_message',
        action: 'viewed',
        value: 'polling_failed',
      };

      genzoTrackActionEvent(
        API_BASE_URL,
        wegoAnalyticsClientId,
        wegoAnalyticsClientSessionId,
        user?.userHash,
        eventData,
        generateCUID(),
      );
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.textAndIcon}>
        <WarningIcon className={styles.warningIcons} />
        <div className={styles.text}>{translations.polling_error_message}</div>
      </div>
      <div className={styles.refreshButton} onClick={onRefreshClick}>
        <RefreshIcon className={styles.refreshIcon} />
        {translations.today_widget_refresh}
      </div>
    </div>
  );
};

export default FlightMissingNoticeBar;
